// Resolves the in-app route a notification should open, based on its
// related_type/related_id and the current user's role. Returns a path string
// or null when there is no meaningful target.
export function notificationTarget(n, role) {
  const id = n?.related_id;
  const isEmployee = role === 'employee';
  switch (n?.related_type) {
    case 'onboarding':
      return id ? `/onboarding/${id}` : '/onboarding';
    case 'task':
      if (!id) return isEmployee ? '/employee/tasks' : '/hr/tasks';
      return isEmployee ? `/employee/tasks/${id}` : `/hr/tasks/${id}`;
    case 'task_request':
      return isEmployee ? '/employee/tasks' : '/hr/tasks';
    case 'issue':
      return isEmployee ? '/employee/issues' : `/hr/issues${id ? `?open=${id}` : ''}`;
    case 'leave':
      return isEmployee ? '/employee/leaves' : '/hr/leaves';
    case 'concern':
      return isEmployee ? '/employee/concerns' : '/hr/concerns';
    case 'meeting':
      return isEmployee ? '/employee/dashboard' : `/hr/meetings${id ? `?open=${id}` : ''}`;
    case 'feedback':
      return isEmployee ? '/employee/feedback' : '/hr/employees';
    case 'chat':
      return '/chat';
    case 'expense':
      return '/expenses';
    case 'admin_message':
      return '/admin-messages';
    default:
      return null;
  }
}
